<template>
  <v-container fluid>
    <v-layout justify-center :align-center="tickets.length == 0" :align-start="tickets.length > 0">
      <v-fade-transition appear v-if="tickets.length > 0">
        <v-layout>
          <v-expansion-panels v-model="selectedId">
            <v-expansion-panel v-for="(ticket, index) in tickets" :key="index">
              <v-expansion-panel-header>
                <v-layout align-center>
                  <span>{{ticket.id}}</span>
                  <v-chip
                    class="ml-3"
                    small
                    :color="ticketState[ticket.status[ticket.status.length - 1].status].backColor"
                    :text-color="ticketState[ticket.status[ticket.status.length - 1].status].textColor"
                  >{{ticketState[ticket.status[ticket.status.length - 1].status].text}}</v-chip>
                </v-layout>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div>
                  <v-layout>
                    <v-flex xs2>ประเภทแจ้งซ่อม</v-flex>
                    <v-flex>
                      {{ticket.type}}
                      <template
                        v-if="ticket.typeOther.length > 0"
                      >{{" "}}({{ticket.ticket.typeOther}})</template>
                    </v-flex>
                  </v-layout>
                  <v-layout class="mt-5">
                    <v-flex xs2>แจ้งซ่อมเมื่อ</v-flex>
                    <v-flex>{{formatedDate(ticket.createdAt.seconds)}}</v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs2>ผู้แจ้งซ่อม</v-flex>
                    <v-flex>{{ticket.callName}} ({{ticket.callPhoneNumber}})</v-flex>
                  </v-layout>
                  <v-layout class="mt-5">
                    <v-flex xs2>อาการเสียเบื้องต้น</v-flex>
                    <v-flex>{{ticket.faultType}}</v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs2>อาการเสียเพิ่มเติม</v-flex>
                    <v-flex>{{ticket.faultInfo}}</v-flex>
                  </v-layout>
                  <v-layout class="mt-5">
                    <v-flex xs2>รูปภาพอาการเสีย</v-flex>
                  </v-layout>
                  <v-layout wrap justify-start>
                    <template v-if="images.length == 0">
                      <v-progress-linear :indeterminate="true"></v-progress-linear>
                    </template>
                    <template v-else>
                      <v-fade-transition group appear>
                        <a
                          :href="image"
                          v-for="(image, index) in images"
                          :key="index"
                          target="_blank"
                          class="mr-3"
                        >
                          <v-avatar tile size="128">
                            <img :src="image" />
                          </v-avatar>
                        </a>
                      </v-fade-transition>
                    </template>
                  </v-layout>
                  <v-layout class="mt-5">
                    <v-btn outlined class="mr-4" color="primary" @click="prepareEdit(ticket)">แก้ไข</v-btn>
                    <v-dialog
                      v-if="!isClosed(ticket)"
                      v-model="dialogs.addProgress.is"
                      :persistent="dialogs.isLoading"
                      max-width="450"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn outlined color="green" v-on="on">เพิ่มความคืบหน้า</v-btn>
                      </template>
                      <v-card :loading="dialogs.isLoading">
                        <v-card-title class="headline">เพิ่มความคืบหน้า</v-card-title>
                        <v-card-text>
                          ประเภทความคืบหน้า
                          <v-layout row wrap>
                            <v-chip
                              :disabled="dialogs.isLoading"
                              v-for="(value, index) in ticketState"
                              @click.native="dialogs.addProgress.selectedType = index"
                              class="mx-3 my-1"
                              :key="index"
                              filter
                              :input-value="dialogs.addProgress.selectedType === index"
                            >{{value.text}}</v-chip>
                          </v-layout>ความคืบหน้าต่าง ๆ
                          <v-layout row wrap>
                            <v-chip
                              :disabled="dialogs.isLoading"
                              v-for="(value, index) in reasonPreset[dialogs.addProgress.selectedType]"
                              @click="dialogs.addProgress.reason += value"
                              class="mx-3 my-1"
                              :key="index"
                            >{{value}}</v-chip>
                          </v-layout>
                          <v-textarea
                            :disabled="dialogs.isLoading"
                            autofocus
                            v-model="dialogs.addProgress.reason"
                          ></v-textarea>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            :disabled="dialogs.isLoading"
                            color="primary"
                            text
                            @click.native="dialogs.addProgress.is = false"
                          >ยกเลิก</v-btn>
                          <v-btn
                            :disabled="dialogs.isLoading"
                            color="green"
                            text
                            @click.native="addProgressToTicket(selectedTicket)"
                          >เพิ่มความคืบหน้า</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-spacer />
                    <v-dialog
                      v-if="!isClosed(ticket)"
                      v-model="dialogs.close.is"
                      :persistent="dialogs.isLoading"
                      max-width="290"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn outlined color="red" dark v-on="on">ปิดงานซ่อม</v-btn>
                      </template>
                      <v-card :loading="dialogs.isLoading">
                        <v-card-title class="headline">ปิดงานซ่อม</v-card-title>
                        <v-card-text>
                          สาเหตุที่ปิดงานซ่อม
                          <v-layout row wrap>
                            <v-chip
                              :disabled="dialogs.isLoading"
                              v-for="(value, index) in reasonPreset.closed"
                              @click="dialogs.close.reason += value"
                              class="mx-3 my-1"
                              :key="index"
                            >{{value}}</v-chip>
                          </v-layout>
                          <v-textarea
                            :disabled="dialogs.isLoading"
                            autofocus
                            v-model="dialogs.close.reason"
                          ></v-textarea>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            :disabled="dialogs.isLoading"
                            color="primary"
                            text
                            @click.native="dialogs.close.is = false"
                          >ยกเลิก</v-btn>
                          <v-btn
                            :disabled="dialogs.isLoading"
                            color="red"
                            text
                            @click.native="closeTicket(selectedTicket)"
                          >ปิดงานซ่อม</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-dialog
            v-model="dialogs.edit.is"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <template v-slot:activator="{ on }"></template>
            <v-card tile>
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="dialogs.edit.is = false">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>แก้ไขใบสั่งซื้อที่ {{ selectedTicket }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                  <v-btn dark text @click="dialogs.edit.is = false">Save</v-btn>
                </v-toolbar-items>
              </v-toolbar>
              <v-list three-line subheader></v-list>
              <v-subheader>ข้อมูลทั่วไป</v-subheader>
              <v-card-text>
                <v-text-field v-model="dialogs.edit.data.callName" label="ผู้แจ้งซ่อม"></v-text-field>
                <v-text-field v-model="dialogs.edit.data.callFrom" label="สถานที่แจ้งซ่อม"></v-text-field>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-layout>
      </v-fade-transition>
      <v-progress-circular indeterminate color="primary" v-else></v-progress-circular>
    </v-layout>
  </v-container>
</template>
<style>
</style>
<script>
import firebase from "../../firebase";
import "firebase/firestore";
import "firebase/storage";
import ticketState from "../../ticket-state";

export default {
  data: () => ({
    tickets: [],
    selectedId: null,
    images: [],
    imagePromise: null,
    ticketState: ticketState.status,
    reasonPreset: ticketState.preset,
    dialogs: {
      isLoading: false,
      edit: {
        is: false,
        data: {}
      },
      close: {
        reason: "",
        is: false
      },
      addProgress: {
        reason: "",
        selectedType: "",
        is: false
      }
    }
  }),
  firestore: {
    tickets: firebase
      .firestore()
      .collection("tickets")
      .orderBy("updatedAt", "desc")
  },
  methods: {
    isClosed(ticket) {
      return ticket.status[ticket.status.length - 1].status == "closed";
    },
    prepareEdit(ticket) {
      this.dialogs.edit.is = true;
      this.dialogs.edit.data = { ...ticket };
    },
    formatedDate(date) {
      var _date = new Date(date * 1000);
      return `${_date.getDate()}/${_date.getMonth() + 1}/${_date.getFullYear() +
        543} ${_date
        .getHours()
        .toString()
        .padStart(2, "0")}:${_date
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;
    },
    ticketImage(ticketId) {
      return firebase
        .storage()
        .ref("ticket-images")
        .child(ticketId)
        .list();
    },
    addProgressToTicket(ticketId) {
      this.dialogs.isLoading = true;
      firebase
        .firestore()
        .collection("tickets")
        .doc(ticketId)
        .get();
      firebase
        .firestore()
        .collection("tickets")
        .doc(ticketId)
        .get()
        .then(result => {
          let status = result.data().status;
          status.push({
            status: this.dialogs.addProgress.selectedType,
            reason: this.dialogs.addProgress.reason,
            createdAt: new Date()
          });
          return firebase
            .firestore()
            .collection("tickets")
            .doc(ticketId)
            .update({ status: status, updatedAt: new Date() })
            .then(() => {
              this.dialogs.isLoading = false;
              this.dialogs.addProgress = {
                reason: "",
                selectedType: "",
                is: false
              };
            });
        })
        .catch(reason => {
          console.debug(reason);
        })
        .finally(() => {
          this.dialogs.isLoading = false;
        });
    },
    closeTicket(ticketId) {
      this.dialogs.isLoading = true;
      firebase
        .firestore()
        .collection("tickets")
        .doc(ticketId)
        .get();
      firebase
        .firestore()
        .collection("tickets")
        .doc(ticketId)
        .get()
        .then(result => {
          let status = result.data().status;
          status.push({
            status: "closed",
            reason: this.dialogs.close.reason,
            createdAt: new Date()
          });
          return firebase
            .firestore()
            .collection("tickets")
            .doc(ticketId)
            .update({ status: status, updatedAt: new Date() })
            .then(() => {
              this.dialogs.isLoading = false;
              this.dialogs.close.is = false;
            });
        })
        .catch(reason => {
          console.debug(reason);
        })
        .finally(() => {
          this.dialogs.isLoading = false;
        });
    }
  },
  computed: {
    selectedTicket() {
      return this.selectedId != undefined
        ? this.tickets[this.selectedId].id
        : "";
    }
  },
  watch: {
    selectedId() {
      this.images = [];
      if (this.selectedTicket == "") return;
      this.imagePromise = this.ticketImage(this.selectedTicket);
      this.imagePromise.then(result => {
        this.images = [];
        Promise.all(
          result.items.map(image => {
            return image.getDownloadURL();
          })
        ).then(result => {
          this.images = result;
        });
      });
    }
  }
};
</script>